import { useState } from 'react';
import PromoCodeModal from './PromoCodeModal';
import './ReservationSummary.css';

const ReservationSummary = ({ vehicle, details, pricing }) => {
  const [showPromoModal, setShowPromoModal] = useState(false);

  return (
    <div className="reservation-summary">
      <div className="summary-header">
        <h3>Tu reserva</h3>
        <span className="duration">{details.duration}</span>
      </div>

      <div className="vehicle-preview">
        <img src={vehicle.image} alt={vehicle.name} />
        <h4>{vehicle.name}</h4>
        <p>{vehicle.category}</p>
      </div>

      <div className="guarantees">
        {details.guarantees.map((guarantee, index) => (
          <div key={index} className="guarantee-item">
            <span className="guarantee-icon">ℹ️</span>
            <span>{guarantee.text}</span>
            <strong>{guarantee.value}</strong>
          </div>
        ))}
      </div>

      <div className="trip-details">
        <h4>Retiro y devolución</h4>
        <div className="trip-item">
          <span className="trip-icon">{details.pickup.icon || '📍'}</span>
          <div>
            <p className="trip-location">{details.pickup.location}</p>
            <p className="trip-datetime">{details.pickup.datetime}</p>
          </div>
        </div>
        <div className="trip-item">
          <span className="trip-icon">{details.return.icon || '📍'}</span>
          <div>
            <p className="trip-location">{details.return.location}</p>
            <p className="trip-datetime">{details.return.datetime}</p>
          </div>
        </div>
      </div>

      <div className="price-breakdown">
        <h4>Detalle de precio</h4>
        {pricing.items.map((item, index) => (
          <div key={index} className="price-item">
            <span>{item.label}</span>
            <span>{item.value}</span>
          </div>
        ))}
      </div>

      <div className="total-price">
        <span>TOTAL</span>
        <strong>$ {pricing.total.toLocaleString('es-AR')}</strong>
      </div>

      {pricing.promoCode && (
        <button className="promo-button" onClick={() => setShowPromoModal(true)}>
          🏷️ TENGO UN CÓDIGO PROMO
        </button>
      )}

      {pricing.savings && (
        <div className="savings">
          💰 $ {pricing.savings.toLocaleString('es-AR')} de ahorro con este pago
        </div>
      )}

      <PromoCodeModal
        isOpen={showPromoModal}
        onClose={() => setShowPromoModal(false)}
      />
    </div>
  );
};

export default ReservationSummary;
